import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import MZDListItem from './mzdlist-item';
import HFMDragDropContext from 'common/components/hfm-drag-drop-context';

import DeleteButton from 'common/components/delete-button';

@inject('playlistStore')
@observer
class MZDList extends React.Component {
	render () {
		const { playlistStore, genreID='0', returnURL="/manage-lists" } = this.props;
		const playlists = playlistStore.getPlaylistsByGenre(genreID);

		return (
			<div className="grid-x grid-padding-x"  style={ {height: '100%'} }>
				<HFMDragDropContext
					dragDropList={ playlists }
					onDragEnd={ this.onDragEnd }
					ItemLabel={ this.renderLabel }
					ItemButton={ this.renderRemoveButton } 
					styleObj={{width: '51.7vw', marginLeft: '1.9vw', padding: '0 0.5vw 0 0.5vw'}}
				/>
			</div>
		);
	}

	@autobind
	onDragEnd (dropResult) { //{ source: { index: startIndex }, destination: { index: endIndex } }) {
		console.log("======ONDRAGEND=====");
		const { playlistStore } = this.props;
		// const { _id, genreID } = this.getPlaylist();
		console.warn(dropResult);
		// console.warn(_id);
		// console.warn(genreID);
		// playlistStore.reorderPlaylist(dropResult, _id);
		playlistStore.reorderListSet(dropResult);
		
	}

	@autobind
	renderRemoveButton (playlist) {
		return (
			// <DeleteButton
			// 	orientation="right"
			// 	warningText={ `Really remove ${ playlist.title }?` }
			// 	onConfirmClick={ this.onConfirmClick }
			// >
			// 	<button
			// 		className="button alert clear"
			// 		data-ta="listItemDeleteBtn"
			// 	>
			// 		<span className="fas fa-trash margin-0"></span>
			// 	</button>
			// </DeleteButton>
			null
		);
	}

	@autobind
	renderLabel ( dropList ) {
		const { returnURL="/manage-lists" } = this.props;
		return (
			<div key={ dropList._id } className={ `cell small-12` }>
				<MZDListItem playlist={ dropList } returnURL={ returnURL } />
			</div>
		);
	}

	@autobind
	onConfirmClick () {
		const { playlistStore, playlist } = this.props;
		playlistStore.deleteItem(playlist);
	}
}

export default MZDList;
